import { accountFullName, accountPosition, fieldService, isCorporateAccount, isPropertyAccount, isFieldAccount, readable } from '../lib/accountIdentity';

// Short acronym for a corporate title: "Chief Executive Officer" → "CEO",
// "General Counsel" → "GC". All-caps words (VP) are kept whole. Falls back
// to the full title when the acronym would be a single letter.
const titleAcronym = (s) => {
  const skip = new Set(['of', 'and', 'the', 'for', 'a', 'an', 'to', 'on', 'in', '&']);
  const words = String(s || '').split(/[^A-Za-z]+/).filter(Boolean).filter((w) => !skip.has(w.toLowerCase()));
  const abbr = words.map((w) => (w === w.toUpperCase() ? w : w[0])).join('').toUpperCase();
  return abbr.length >= 2 ? abbr : String(s || '');
};

export default function IdentityBadge({ user, property }) {
  if (!user) return null;
  const corporate = isCorporateAccount(user), management = isPropertyAccount(user), field = isFieldAccount(user);
  // Field staff (Valet/Cleaners) badge: service · Role · Region code only.
  const title = field ? `${fieldService(user)} · ${readable(user.role === 'manager' ? 'regional_manager' : user.role)}`
    : corporate ? titleAcronym(accountPosition(user)) : accountPosition(user);
  const code = corporate ? user.department || readable(user.admin_department) : management || user.role === 'tenant'
    ? property?.necs_code || property?.property_code || user.property_code || user.property_necs_code || property?.property_id || user.property_id
    : field ? (user.region_code || user.region) : null;
  return <section className="px-3 pt-3 pb-2 min-w-0" data-testid="sidebar-identity-badge">
    <div className="border border-[#C9A962] rounded-md px-3 py-1.5 text-center break-words" data-testid="sidebar-identity-code">
      <p className="text-xs leading-snug [overflow-wrap:anywhere]">
        <span className="font-bold text-[#C9A962]" data-testid="sidebar-identity-role">{title}</span>
        {code ? <span className="text-zinc-300" data-testid="sidebar-identity-code-value"> · {code}</span> : null}
      </p>
    </div>
  </section>;
}

export function SidebarUserInfo({ user, property }) {
  if (!user) return null;
  const corporate = isCorporateAccount(user), management = isPropertyAccount(user);
  return <section className="px-4 pt-3 pb-4 border-t border-zinc-800 min-w-0 space-y-1" data-testid="sidebar-user-info">
    {corporate ? <p className="text-[10px] text-[#C9A962] [overflow-wrap:anywhere]" data-testid="sidebar-user-info-badge">{user.badge_number || 'Badge not assigned'}</p>
      : isFieldAccount(user) ? <p className="text-[11px] text-[#C9A962] break-words" data-testid="sidebar-user-info-title">{accountPosition(user)}</p> : null}
    <p className="text-xs font-semibold text-white break-words" data-testid="sidebar-user-info-name">{accountFullName(user)}</p>
    {management && <p className="text-[11px] text-zinc-300 break-words" data-testid="sidebar-user-info-property">{property?.property_name || property?.name || user.property_name || 'Property not assigned'}</p>}
    <p className="text-[10px] text-zinc-400 [overflow-wrap:anywhere]" data-testid="sidebar-user-info-email">{user.office_email || user.email}</p>
  </section>;
}